import styles from './ImageSection.module.scss'
import NextLink from 'next/link'
import NextImage from 'next/image'
import { IFeedRecord } from '@/interfaces/IFeedRecord'
import imageService from '@/modules/imageService'

interface ImageSectionProps {
  record: IFeedRecord
}

function ImageSection ({ record }: ImageSectionProps) {
  return (
    <>
      {record.image &&
        <NextLink
          href={`/${record.slug}`}
        >
          <div className={styles.recordImageWrapper}>
            <NextImage
              src={imageService.postImageURL(record.id, record.image)}
              alt="placeholder"
              width={450}
              height={450}
              className={styles.recordImage}
            />
          </div>
        </NextLink>
      }
    </>
  )
}

export default ImageSection
